import { Step1FormConditionsProps, Step1FormOptionsProps, Step1FormProps } from '../types'
import React from 'react'
import { GenericDropdownItem } from '../../../../types'
import { ActivationObject, PersonAuthorisationType } from '../../../providers/ActivationObjectProvider/types'
import { LegalObjectTypeList, PhysicalObjectTypeList } from '../../Step2/constants'

const useStep1FormConditions = (
    form: Step1FormProps['form'],
    options: Step1FormOptionsProps,
    activationObject?: ActivationObject
): Step1FormConditionsProps => {
    // zmena person type
    const { setValue } = form
    const personAuthorisationType = form.watch('personAuthorisationType')
    const useSettingsAnotherContract = form.watch('useSettingsAnotherContract')
    const personType = form.watch('personType')
    // nastaveni 1. polozky permissions, kdyz neni vybrana, nebo je zmenen seznam
    React.useEffect(() => {
        if (
            !personAuthorisationType ||
            options.permissions.findIndex(
                (perm: GenericDropdownItem<PersonAuthorisationType>) => perm.value === personAuthorisationType
            ) === -1
        ) {
            setValue('personAuthorisationType', options.permissions[0].value)
        }
    }, [options.permissions, personAuthorisationType, personType, setValue])

    React.useEffect(() => {
        if (!useSettingsAnotherContract) setValue('numberAnotherContract', undefined)
        if (useSettingsAnotherContract && options.contracts.data && options.contracts.data.length > 0)
            setValue('numberAnotherContract', options.contracts.data[0].numberContract)
    }, [options.contracts.data, setValue, useSettingsAnotherContract])

    // update objectType if it is not valid
    const objectType = form.watch('objectType')
    const legalForm = form.watch('personType')
    React.useEffect(() => {
        if (objectType) {
            if (legalForm === 'Legal' && !LegalObjectTypeList.find((x) => x.value === objectType)) {
                setValue('objectType', LegalObjectTypeList[0].value)
            }
            if (legalForm === 'Physical' && !PhysicalObjectTypeList.find((x) => x.value === objectType)) {
                setValue('objectType', PhysicalObjectTypeList[0].value)
            }
        }
    }, [legalForm, objectType, setValue])
    return {
        showUploadFile: personAuthorisationType === 'AuthRepresentative',
        showAnotherAuthorisationType: personAuthorisationType === 'Other',
        showContracts: useSettingsAnotherContract || false,
    }
}

export default useStep1FormConditions
